module.exports = __webpack_public_path__ + "img/image_12.3cf8007c.png";